module.exports = __webpack_public_path__ + "static/turtle-creek-house08-2d2246163d9d533ce7a0ee09c3a4aa1f.jpg";